export type SETUP_STEP_TYPES =
  | 'get-started'
  | 'heart-rate-monitors'
  | 'mobile-app'
  | 'configure-widgets'
  | 'go-live'
  | 'bro-plan';

export const SETUP_STEPS_ARRAY: SETUP_STEP_TYPES[] = [
  'get-started',
  'heart-rate-monitors',
  'mobile-app',
  'configure-widgets',
  'go-live',
  'bro-plan',
];
